/** Shared top app bar: title on the left, one optional icon action on the right. */
export default function TopBar({ title, action }) {
  return (
    <div className="top-bar">
      <h1>{title}</h1>
      {action}
    </div>
  );
}
